export interface ErrorCodeDisplay {
  code: string;
  friendlyName: string;
}

function toFriendlyName(code: string): string {
  // Split PascalCase into words: "NotAllMenuItemsFound" -> "Not All Menu Items Found"
  return code.replace(/([A-Z])/g, ' $1').trim();
}

// Mirror of Dish.Core/Services/Shared/DishImportErrorCodes.cs
const RAW_CODES: string[] = [
  // Client / Customer Setup Errors
  'ExternalProviderNotMapped',
  'CustomerNumberNotMapped',
  'ClientIntegrationForbidden',
  'MajorAccountNotMapped',

  // Menu Import Errors
  'NotAllMenuItemsFound',
  'NotAllMenuClientProductMappingsFound',

  // Product Import Errors
  'ClientProductMappingNotFound',

  // Meal Errors
  'MealNotBuilt',

  // Location Errors
  'LocationNotBuilt',

  // Filter Errors
  'NoAllergensFound',
  'SomeAllergensNotFound',
  'NoPreferencesFound',
  'SomePreferencesNotFound',
];

export const ERROR_CODES: ErrorCodeDisplay[] = RAW_CODES.map((code) => ({
  code,
  friendlyName: toFriendlyName(code),
}));
